import { render } from "./IframeContainer.vue?vue&type=template&id=05c4ef7c&scoped=true"
import script from "./IframeContainer.vue?vue&type=script&lang=js"
export * from "./IframeContainer.vue?vue&type=script&lang=js"

import "./IframeContainer.vue?vue&type=style&index=0&id=05c4ef7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c4ef7c"]])

export default __exports__